// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"b2aa5fd0","376":"a18cce66","622":"e16cdef4","896":"1f2abd25"}[chunkId] + ".chunk.css";
};